import SlateDocument from "types/SlateDocument";

import MediaLink from "./MediaLink";

const parseUrl = (url, mediaUrl) => {
  if (url?.length > 0) {
    return url;
  }
  if (mediaUrl?.length > 0) {
    return mediaUrl;
  }
  return null;
};

const domainFor = url => {
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.hostname;
  } catch {
    return url;
  }
};

export interface BookReviewLinkProps {
  userBook: {
    url?: string;
    mediaUrl?: string;
    reviewSlate: SlateDocument | null;
  };
}
const BookReviewLink = ({ userBook }: BookReviewLinkProps) => {
  const url = parseUrl(userBook.url, userBook.mediaUrl);
  const displayUrl = domainFor(parseUrl(userBook.url, userBook.mediaUrl));

  // No review means no link
  if (!userBook.reviewSlate || !url || url.length === 0) {
    return <></>;
  }

  return (
    <p className="text-gray-600 dark:text-gray-400 text-sm">
      Originally posted at{" "}
      <a
        href={url}
        target="_blank"
        className="text-indigo-500 dark:text-yellow-400 hover:underline"
        rel="noreferrer"
      >
        {displayUrl}
      </a>
      .
      {userBook.mediaUrl && (
        <span className="ml-2">
          <MediaLink url={userBook.mediaUrl} />
        </span>
      )}
    </p>
  );
};

export default BookReviewLink;
